module.exports = __webpack_public_path__ + "img/segura-icon-verde.4efae509.svg";